import './ccf-call-ringing-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallRingingIconProps extends SvgIconProps  {}
/**
 * Component used to display call ringing status Icon
 * @param props - CcfCallRingingIconProps
 * @example - <CcfCallRingingIcon />
 * @returns SVG of call ringing icon
 */
export function CcfCallRingingIcon(props: CcfCallRingingIconProps) {
  return (
    <SvgIcon {...props}>
     <path className="a" d="M7.734-33.542s-.557.9-.608.976-.159.3-.678.15a7.529,7.529,0,0,1-3.073-2.216,7.816,7.816,0,0,1-2.145-3.174c-.148-.536.071-.647.145-.7s.945-.629.945-.629c.586-.355-.077-1.874-1.146-2.6-.789-.539-1.136-.487-1.467-.222a8.539,8.539,0,0,0-1.439,1.524,1.485,1.485,0,0,0-.252,1.04,8.881,8.881,0,0,0,1.176,3.27,15.651,15.651,0,0,0,2.478,3.256,15.34,15.34,0,0,0,3.152,2.56A8.237,8.237,0,0,0,7.988-29.1a1.372,1.372,0,0,0,1.007-.26,8.52,8.52,0,0,0,1.475-1.487c.257-.342.308-.7-.214-1.516C9.548-33.463,8.078-34.147,7.734-33.542Z" transform="translate(2 42.936)" />
      <g transform="translate(8.067)">
        <g transform="translate(0 0)">
          <path className="a" d="M.949,4.86,3.068,2.669l.835.865c.145.148.3.1.337-.1L4.859.306c.039-.2-.09-.341-.29-.3L1.547.645c-.2.043-.245.2-.1.348l.835.863L.163,4.047a.589.589,0,0,0,0,.814A.546.546,0,0,0,.949,4.86Z" transform="translate(4.866 5.027) rotate(180)" />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfCallRingingIcon;
